import React, { ReactElement, useEffect } from 'react';

import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { useLocation, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import routes from '../../../routing/routes';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import useLegMaterialDetailPozicia from '../../../hooks/useLegMaterialDetailPozicia';
import ObalMaterialuNrSrZaBezchybnostWrapper
  from '../../../module/PracovnyKrok/PodpisPredseda/ObalMaterialuNrSrZaBezchybnostWrapper';
import SuccessMessages from '../../../module/SuccessMessages';

const ObalMaterialuNrSrBezchybnostCreatePage = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegMaterialDetailPozicia(type, year, index, PracovnyKrokEnum.ODOSLAT_PREDSEDOVI_VLADY);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Legislatívne procesy',
          to: routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Odoslanie na podpis predsedovi vlády',
          to: routes.procesy.podpisPredseda.withParams(type, year, index, pracovnyKrokId),
        },
        {
          heading: 'Obal materiálu NR SR za bezchybnosť',
          to: pathname,
        }]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.hasPracovnyKrokInZasobnikPrace}
          hasOpravneniePracovneKroky={materialDetail?.hasOpravneniePracovneKroky}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Obal materiálu NR SR za bezchybnosť"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                  withBackLink
                />
                <ObalMaterialuNrSrZaBezchybnostWrapper
                  materialDetail={materialDetail}
                  type={type}
                  year={year}
                  index={index}
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default ObalMaterialuNrSrBezchybnostCreatePage;
